import React, { useEffect } from 'react';
import { TreeItem } from '@mui/x-tree-view/TreeItem';


export default function WhiteTreeItem(props) {

    useEffect(() => {
    }, [])

    return (
        <TreeItem
            sx={{
                color: 'white'
            }}
            {...props}
            nodeId={props.nodeId} 
            label={props.label}>
            {props.children}
        </TreeItem>
    );
}
